/* tslint:disable */
import { css, ThemedCssFunction } from 'styled-components'

interface IMedia {
  desktop: number,
  laptop: number,
  phone: number,
  tablet: number,
  xLarge: number
}

const sizes: IMedia = {
  desktop: 1170,
  laptop: 992,
  phone: 376,
  tablet: 768,
  xLarge: 1400,
}

interface IMediaKeys {
  desktop: ThemedCssFunction<any>,
  laptop: ThemedCssFunction<any>,
  phone: ThemedCssFunction<any>,
  tablet: ThemedCssFunction<any>,
  xLarge: ThemedCssFunction<any>
}

// export const media: IMediaKeys = Object.keys(sizes).reduce((acc: any, label: string) => {
//   acc[label] = (...args: any) => {
//     // @ts-ignore
//     return css`
// 			@media (min-width: ${sizes[label]}px) {
// 				// @ts-ignore
// 				${css(...args)}
// 			}
// 		`
//   }
//   return acc
// }, {})

const size: { [id: string]: string } = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopTw: '1280px',
  laptopL: '1440px',
  desktop: '1700px',
}

interface IDeviceKeys {
  mobileS: string,
  mobileM: string,
  mobileL: string,
  tablet: string,
  laptop: string,
  laptopL: string,
  laptopTw: string,
  desktop: string,
}

export const device: IDeviceKeys = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  laptopTw: `(min-width: ${size.laptopTw})`,
  desktop: `(min-width: ${size.desktop})`,
}
